import { CARD_GRID } from "../../../../components/LayoutFactory/constants";
import { CardVariantsEnum } from "../../../../utils/dataTransform/ContentQueryWidget/types";

export const TOTAL_NUMBER_OF_CARDS_TO_SHOW = 7;
export const NUMBER_OF_MORE_LIKE_THIS_TO_SHOW = 3;
export const TOTAL_NUMBER_OF_LOADING_CARD_TO_SHOW = 3;

export const PROMISE_NAMES = {
    MORE_LIKE_THIS: "More Like This",
    RECOMMENDATIONS: "Recommendations",
};

export const DEFAULT_BASE_LAYOUT = {
    name: CARD_GRID,
    columns: 1,
    rows: TOTAL_NUMBER_OF_LOADING_CARD_TO_SHOW,
    variant: CardVariantsEnum.HORIZONTAL,
    isFlexible: false,
};
